/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_appsync_graphqlEndpoint": "https://mgiiajzdurcqfoia6juz3ihpwi.appsync-api.us-east-1.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-1",
    "aws_appsync_authenticationType": "AWS_IAM",
    "aws_cognito_identity_pool_id": "us-east-1:f66a9a60-e04d-4fdb-b85a-fefda037289b",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_7Iygh15Gl",
    "aws_user_pools_web_client_id": "686tfpcf792pple4ik9q71i27j",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "PHONE_NUMBER"
    ],
    "aws_dynamodb_all_tables_region": "us-east-1",
    "aws_dynamodb_table_schemas": [
        {
            "tableName": "SubmittedApplicationForm-ibrmmxmpqzhm5m7bfe2izfnxxa-prod",
            "region": "us-east-1"
        },
        {
            "tableName": "SubmittedShelfApplicationForm-ibrmmxmpqzhm5m7bfe2izfnxxa-prod",
            "region": "us-east-1"
        }
    ]
};


export default awsmobile;
